<!--
 * @Author: mazhigang
 * @Date: 2023-09-02 22:16:19
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-14 22:18:36
-->
<template>
  <div style="max-width: 100vw;overflow: hidden;width: 100vw;height: 100vh;">
    <div class="pageTop"></div>
    <div class="box">
      <div class="user" v-if="inviteId != ''">
        <img :src="userInfo.headerImg" alt="" />
        <div style="margin-left: 17px;">
          <div class="userName">
            {{
              userInfo.userType == 0
                ? userInfo.companyName
                : userInfo.inviteName
            }}
          </div>
          <div class="info">
            邀请您加入咖德保安平台，加入后赚取更多任务收益！
          </div>
        </div>
      </div>
      <div class="phone">
        <el-input
          placeholder="请输入手机号"
          v-model="phone"
          maxlength="11"
          @input="inputPhone"
          class="pageInput"
        >
        </el-input>
      </div>
      <div class="code" style="padding-right: 10px;box-sizing: border-box;">
        <el-input
          placeholder="请输入验证码"
          maxlength="6"
          v-model="code"
          @input="inputCode"
          class="pageInput"
        >
        </el-input>
        <div class="getCode" @click="getCode" v-if="canClick">| 获取验证码</div>
        <div class="getCode" v-if="!canClick">| {{ time }}秒后重试</div>
      </div>
      <div :class="['btn', isOk == false ? 'active' : '']" @click="login">
        注册
      </div>
      <AliCaptcha :captcha-config="captchaConfig" />
      <div
        style="display: flex;align-items: center;justify-content: center;margin-top: 10px;"
      >
        <el-checkbox v-model="checked" @change="select"></el-checkbox>
        <div style="margin-left: 5px;font-size: 12px;">
          已阅读并同意《用户协议》和《隐私协议》
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AliCaptcha from "../../components/AliCaptcha.vue";
export default {
  components: {
    AliCaptcha
  },
  data() {
    return {
      phone: "",
      code: "",
      inviteId: "",
      userInfo: "",
      source: "",
      canClick: true,
      time: 60,
      checked: false,
      isOk: false,
      canLogin: true,
      captchaConfig: {
        config: {
          captchaId: "dccd8ee29e973f26c68c819037aa68eb",
          product: "bind"
        },
        handler: this.captchaHandler
      }
    };
  },
  mounted() {
    const fingerprint = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      screen: {
        width: screen.width,
        height: screen.height,
        colorDepth: screen.colorDepth
      },
      timezone: new Date().getTimezoneOffset(),
      plugins: Array.from(navigator.plugins)
        .map(p => p.name)
        .join(","),
      webglVendor: (() => {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        return gl ? gl.getParameter(gl.VENDOR) : "";
      })(),
      fonts: (() => {
        const fonts = [];
        const testString = "abcdefghijklmnopqrstuvwxyz";
        const testFont = "Comic Sans MS";
        const ctx = document.createElement("canvas").getContext("2d");
        ctx.font = "72px monospace";
        const defaultWidth = ctx.measureText(testString).width;
        ctx.font = `72px ${testFont}, monospace`;
        if (ctx.measureText(testString).width !== defaultWidth) {
          fonts.push(testFont);
        }
        return fonts;
      })()
    };
    // 生成哈希（例如使用 SHA-256）
    const hash = async data => {
      const encoder = new TextEncoder();
      const hashBuffer = await crypto.subtle.digest(
        "SHA-256",
        encoder.encode(JSON.stringify(data))
      );
      return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
    };
    let key = hash(fingerprint).then(console.log); // 输出设备指纹
    console.log(key);
    if (this.$route.query.inviterId && this.$route.query.inviterId != "null") {
      this.inviteId = this.$route.query.inviterId;
      this.getInfo();
    }
    if (this.$route.query.source && this.$route.query.source != "null") {
      this.source = this.$route.query.source;
    }
  },
  methods: {
    login1() {
      if (this.captchaConfig.config.product === "bind") {
        if (window.captchaObj) {
          window.captchaObj.showCaptcha();
        } else {
          alert("请等待验证初始化完成");
          return false;
        }
      } else {
        this.validate();
      }
    },

    validate() {
      var result = window.captchaObj.getValidate();
      console.log(result);
      let param = {
        authenticateSigDTO: {
          captchaId: result.captcha_id,
          captchaOutput: result.captcha_output,
          genTime: result.gen_time,
          lotNumber: result.lot_number,
          passToken: result.pass_token
        },
        phone: this.phone,
        type: 2,
        h5Ture: 1
      };
      this.$axios
        .post(`/mapi/api/system/h-sms-send`, param)
        .then(({ data }) => {
          console.log(data);
          this.canClick = false;
          this.countdown();
        })
        .catch()
        .finally();
      // this.canLogin = false;
      // let param = {
      //   isReadProtocol: 1,
      //   inviteId: this.inviteId,
      //   phone: this.phone,
      //   verificationCode: this.code,
      //   h5true: 1
      // };
      // this.$axios
      //   .post(`/mapi/api/common/invite/registerInvite`, param)
      //   .then(({ data }) => {
      //     this.$router.push("/poster");
      //     localStorage.setItem("errorMsg", "");
      //     this.canLogin = true;
      //     return;
      //     let token = data.loginUserVO.accessToken;
      //     let baBodyguardsInfoVO = data.baBodyguardsInfoVO;
      //     localStorage.setItem("TOKEN", token);
      //     localStorage.setItem(
      //       "baBodyguardsInfoVO",
      //       JSON.stringify(baBodyguardsInfoVO)
      //     );
      //     localStorage.setItem("errorMsg", data.rejectReason);
      //     if (data.status == 4 || data.status == 3) {
      //       this.$router.push("/prove");
      //     } else {
      //       this.$router.push("/poster");
      //       localStorage.setItem("errorMsg", "");
      //     }
      //   })
      //   .catch()
      //   .finally();
    },

    captchaHandler(captchaObj) {
      window.captchaObj = captchaObj;
      captchaObj
        .appendTo("#captcha")
        .onReady(function() {
          console.log("ready");
        })
        .onNextReady(function() {
          console.log("nextReady");
        })
        .onBoxShow(function() {
          console.log("boxShow");
        })
        .onError(function(e) {
          console.log(e);
        })
        .onSuccess(() => {
          if (this.captchaConfig.config.product === "bind") {
            this.validate();
          }
        });
    },
    inputCode(val) {
      if (val == "") {
        this.isOk = false;
      } else {
        if (this.phone == "" || this.checked == false) {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    inputPhone(val) {
      if (val == "") {
        this.isOk = false;
      } else {
        if (this.code == "" || this.checked == false) {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    select(val) {
      if (val == false) {
        this.isOk = false;
      } else {
        if (this.code == "" || this.phone == "") {
          this.isOk = false;
        } else {
          this.isOk = true;
        }
      }
    },
    login() {
      if (this.phone == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      if (this.code == "") {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
        return;
      }
      if (this.checked == false) {
        this.$message({
          message: "请阅读并同意《用户协议》和《隐私协议》",
          type: "warning"
        });
        return;
      }
      if (this.source == "") {
        if (this.inviteId == "") {
          this.$message({
            message: "请联系邀请人重新发送正确的邀请链接",
            type: "warning"
          });
          return;
        }
        this.canLogin = false;
        let param = {
          isReadProtocol: 1,
          inviteId: this.inviteId,
          phone: this.phone,
          verificationCode: this.code,
          h5true: 1
        };
        this.$axios
          .post(`/mapi/api/common/invite/registerInvite`, param)
          .then(({ data }) => {
            this.$router.push("/poster");
            localStorage.setItem("errorMsg", "");
            this.canLogin = true;
            return;
            let token = data.loginUserVO.accessToken;
            let baBodyguardsInfoVO = data.baBodyguardsInfoVO;
            localStorage.setItem("TOKEN", token);
            localStorage.setItem(
              "baBodyguardsInfoVO",
              JSON.stringify(baBodyguardsInfoVO)
            );
            localStorage.setItem("errorMsg", data.rejectReason);
            if (data.status == 4 || data.status == 3) {
              this.$router.push("/prove");
            } else {
              this.$router.push("/poster");
              localStorage.setItem("errorMsg", "");
            }
          })
          .catch()
          .finally();
      } else {
        this.canLogin = false;
        let param = {
          isReadProtocol: 1,
          registerChannelCode: this.source,
          phone: this.phone,
          verificationCode: this.code
        };
        this.$axios
          .post(`/mapi/api/bodyguard/code-login-h5`, param)
          .then(({ data }) => {
            this.$router.push("/poster");
            localStorage.setItem("errorMsg", "");
            this.canLogin = true;
            return;
          })
          .catch()
          .finally();
      }
    },
    getCode() {
      if (this.phone == "") {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      this.login1();
    },
    countdown() {
      // 倒计时时间为 0 时结束递归
      if (this.time === 0) {
        this.canClick = true;
        this.time = 60;
        return;
      }
      setTimeout(() => {
        this.countdown(this.time - 1);
        this.time = this.time - 1;
      }, 1000);
    },
    getInfo() {
      let param = {
        inviteId: this.inviteId
      };
      this.$axios
        .post(`/mapi/api/common/invite/getInviter`, param)
        .then(({ data }) => {
          this.userInfo = data;
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style scoped>
input[type="text"],
textarea {
  transform: scale(1);
  transform-origin: 0 0; /* 确保变换从左上角开始 */
}
input,
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.pageTop {
  width: 100vw;
  overflow: hidden;
  height: 130px;
  background-image: url("https://down.baoanlailou.com/00/loginTop.png");
  background-size: 100% 100%;
}
.pageInput {
  transform: scale(1) !important;
  transform-origin: 0 0 !important; /* 确保变换从左上角开始 */
}
.pageInput {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.box {
  width: 100vw;
  overflow: hidden;
  padding: 20px 30px;
  box-sizing: border-box;
  border-radius: 9px;
  margin-top: -20px;
  z-index: 99;
  background: #fff;
}
.user {
  width: 100%;
  padding: 9px 12px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #f9fdff 0%, #f3fbff 100%);
  border-radius: 6px;
  border: 1px solid #1677ff;
  display: flex;
}
.user img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: block;
  flex: none;
}
.userName {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
  line-height: 20px;
  margin-bottom: 4px;
}
.info {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
  line-height: 17px;
}
.phone {
  width: 100%;
  height: 50px;
  background: #f8f9fb;
  margin-top: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.code {
  width: 100%;
  height: 50px;
  background: #f8f9fb;
  margin-top: 30px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.getCode {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1677ff;
  line-height: 17px;
  flex: none;
}
.btn {
  width: 100%;
  height: 44px;
  background: #02b6fc;
  border-radius: 6px;
  text-align: center;
  line-height: 44px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  margin-top: 30px;
}
.active {
  background: #68d1f9;
}
</style>
<style>
.el-input {
  /* width: 100%; */
  height: 100% !important;
  transform: scale(1) !important;
  transform-origin: 0 0 !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}
.el-input__inner {
  height: 100% !important;
  background: transparent !important;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 50px;
  padding: 15px 12px;
  box-sizing: border-box;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue